import './sendDocument.scss';

export const SendDocumentTemplate = (model) => {
	const { fileName, altText, fileIcon, fileSize, fileUrl, messageText } = model;

	const text = messageText
		? `
            <div class="engt-msg-document-text">
                    ${messageText}
            </div>
        `
		: '';

	/* html */
	const html = `
        <div class="engt-msg-document-data">
            <img class="engt-file-icon" src="${fileIcon}" alt="${altText}" loader="lazy"/>
            <a href="${fileUrl}" target="_blank" class="engt-msg-text engt-file-name">
                ${fileSize ? `${fileName} | ${fileSize}` : fileName}
            </a>
        </div>
        ${text}
    `;

	return html;
};
